
// Cette fonction utilise require.context pour charger tous les fichiers image (png, jpg, svg) dans le dossier des icônes, de façon récursive.
export default function loadIcons() {
    // Remarque : Le chemin ici doit pointer vers le dossier "icons" dans "public" si vous utilisez CRA.
    // Pour CRA, tout fichier dans "public" peut être accédé via le chemin absolu, donc on pourra éventuellement le gérer différemment.
    // Ici, nous utilisons require.context pour les fichiers dans src.
    // Si vos images sont dans public, vous devrez peut-être gérer cela manuellement ou via un script.
    const context = require.context('../../public/assets/images/icons', true, /\.(png|jpe?g|svg)$/);
    const iconsByFolder = {};

    context.keys().forEach((key) => {
        const cleanedKey = key.replace('./', '');
        const parts = cleanedKey.split('/');
        const folder = parts.length > 1 ? parts[0] : 'root';
        const path = `/assets/images/icons/${cleanedKey}`;
        if (!iconsByFolder[folder]) {
            iconsByFolder[folder] = [];
        }
        iconsByFolder[folder].push({
            name: parts[parts.length - 1],
            path,
        });
    });

    return iconsByFolder;
}
